import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import SenderInfoPage from "@/pages/senders/SenderInfo/Index";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/senders/$senderId")({
	component: () => {
		const { senderId } = Route.useParams();

		return (
			<DashboardLayout>
				<SenderInfoPage senderId={senderId} />
			</DashboardLayout>
		);
	},
	loader: authMiddleware,
});
